import React, { useEffect, useRef } from "react";
import "./Cursor.css";

const Cursor = () => {
    const dotRef = useRef(null);
    const ringRef = useRef(null);
    const pos = useRef({ x: 0, y: 0 });
    const mouse = useRef({ x: 0, y: 0 });

    useEffect(() => {
        if (window.matchMedia("(max-width: 768px)").matches) return;

        const moveCursor = e => {
            mouse.current.x = e.clientX;
            mouse.current.y = e.clientY;
            if (dotRef.current) {
                dotRef.current.style.transform = `translate(${mouse.current.x}px, ${mouse.current.y}px)`;
            }
        };

        const animate = () => {
            pos.current.x += (mouse.current.x - pos.current.x) * 0.15;
            pos.current.y += (mouse.current.y - pos.current.y) * 0.15;
            if (ringRef.current) {
                ringRef.current.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px)`;
            }
            requestAnimationFrame(animate);
        };

        window.addEventListener("mousemove", moveCursor);
        animate();

        return () => window.removeEventListener("mousemove", moveCursor);
    }, []);

    useEffect(() => {
        if (window.matchMedia("(max-width: 768px)").matches) return;
        const interactiveElements = document.querySelectorAll("a, button, input, textarea");
        interactiveElements.forEach(el => el.classList.add("hover-target"));
    }, []);

    if (window.matchMedia("(max-width: 768px)").matches) return null;

    return (
        <>
            <div ref={dotRef} className="cursor-dot"></div>
            <div ref={ringRef} className="cursor-ring"></div>
        </>
    );
};

export default Cursor;
